import type { SVGProps } from 'react'

interface TrashIconProps extends SVGProps<SVGSVGElement> {}

export function TrashIcon(props: TrashIconProps) {
  return (
    <svg
      width="27"
      height="29"
      viewBox="0 0 27 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_638_627)">
        <mask
          id="mask0_638_627"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="27"
          height="29"
        >
          <path d="M0 3.8147e-06H27V29H0V3.8147e-06Z" fill="white" />
        </mask>
        <g mask="url(#mask0_638_627)">
          <path
            d="M8.54297 25.5862C7.67064 25.5862 6.96094 26.3485 6.96094 27.2854C6.96094 28.2223 7.67064 28.9846 8.54297 28.9846C9.4153 28.9846 10.125 28.2223 10.125 27.2854C10.125 26.3485 9.4153 25.5862 8.54297 25.5862Z"
            fill="currentColor"
          />
          <path
            d="M18.167 25.5862C17.2947 25.5862 16.585 26.3485 16.585 27.2854C16.585 28.2223 17.2947 28.9846 18.167 28.9846C19.0393 28.9846 19.749 28.2223 19.749 27.2854C19.749 26.3485 19.0393 25.5862 18.167 25.5862Z"
            fill="currentColor"
          />
          <path
            d="M26.8413 9.60273C26.6919 9.38925 26.4577 9.26367 26.209 9.26367H0.791008C0.543579 9.26367 0.31044 9.388 0.160885 9.59967C0.0113303 9.81145 -0.0373968 10.086 0.0292067 10.342C0.119593 10.6893 0.780778 12.1907 0.924901 12.735C1.02162 13.1001 1.33222 13.3521 1.68575 13.3521H25.3118C25.6665 13.3521 25.9779 13.0983 26.0735 12.7313C26.2208 12.1657 26.8028 10.9663 26.9689 10.3493C27.0379 10.0927 26.9907 9.81626 26.8413 9.60273Z"
            fill="currentColor"
          />
          <path
            d="M22.5238 7.56445L19.2975 3.77554C19.1476 3.59955 18.9358 3.4993 18.7138 3.4993H18.7111C18.4881 3.50015 18.2758 3.60204 18.1264 3.7799L14.9482 7.56445H22.5238Z"
            fill="currentColor"
          />
          <path
            d="M13.169 6.49364C13.3121 6.68316 13.5756 6.68457 13.7186 6.49494C13.7362 6.47166 13.7544 6.44878 13.7733 6.42635L16.2301 3.50069L13.8402 0.381833C13.651 0.13488 13.3448 0.0187669 13.0441 0.0955715C12.8716 0.139638 12.7198 0.24986 12.6071 0.396843L10.4473 3.21556L13.121 6.43298C13.1375 6.45286 13.1535 6.47308 13.169 6.49364Z"
            fill="currentColor"
          />
          <path
            d="M8.79909 3.78318C8.64901 3.60261 8.43433 3.4993 8.209 3.4993C7.98361 3.4993 7.76893 3.60261 7.61885 3.78318L4.47656 7.56445H11.9414L8.79909 3.78318Z"
            fill="currentColor"
          />
          <path
            d="M11.5757 19.7095L13.6022 17.5109C13.9096 17.1774 14.4104 17.1747 14.7209 17.5047C15.0313 17.8349 15.0339 18.3728 14.7265 18.7063L14.034 19.4576H14.8604C15.1805 19.4576 15.4691 19.6648 15.5914 19.9827C15.7137 20.3005 15.6456 20.6661 15.4189 20.9088L13.2502 23.2312C13.0958 23.3966 12.8937 23.4792 12.6917 23.4792C12.4888 23.4792 12.286 23.3959 12.1315 23.2295C11.823 22.8971 11.8238 22.3592 12.1332 22.028L12.9466 21.1568H12.1379C11.8186 21.1568 11.5307 20.9507 11.4078 20.6343C11.2849 20.3179 11.3511 19.9532 11.5757 19.7095ZM4.46047 27.3906C4.53731 27.784 4.86036 28.0657 5.23461 28.0657H5.46475C5.40964 27.815 5.37958 27.554 5.37958 27.2854C5.37958 25.4116 6.79898 23.887 8.54364 23.887C10.2883 23.887 11.7077 25.4116 11.7077 27.2854C11.7077 27.554 11.6777 27.815 11.6226 28.0657H15.0887C15.0337 27.815 15.0036 27.554 15.0036 27.2854C15.0036 25.4116 16.423 23.887 18.1677 23.887C19.9123 23.887 21.3317 25.4116 21.3317 27.2854C21.3317 27.554 21.3017 27.815 21.2466 28.0657H21.7639C22.1385 28.0657 22.4616 27.7835 22.5382 27.3898C22.7663 26.2167 24.0781 18.3114 24.716 15.0514H2.28223C3.07519 19.1123 4.46047 27.3906 4.46047 27.3906Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_638_627">
          <rect width="27" height="29" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
